export interface BookReviewScope {
  fundId?: string | null
  clientId?: string | null
}

export function bookReviewQuery(
  groupId: string,
  proposalIds: readonly string[],
  scope: BookReviewScope = {}
): string {
  const unique = [...new Set(proposalIds.map(String).filter(Boolean))]
  if (!groupId || unique.length === 0 || unique.length > 50)
    throw new Error('Book review needs between one and fifty proposals')
  const query = new URLSearchParams()
  for (const proposalId of unique) query.append('proposal_id', proposalId)
  if (scope.fundId) query.set('fund_id', scope.fundId)
  else if (scope.clientId) query.set('client_id', scope.clientId)
  return '/api/rk/decks/group/' + encodeURIComponent(groupId) + '/book-review?' + query.toString()
}
